import React from "react";
import "../../styles/footer.css";
import { withNamespaces } from "react-i18next";

const Footer = ({ t }) => {

  const formatPhoneValues = (phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^\d]/g, '');
    return `+351 ${phoneNumber.slice(0, 3)} 
  ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 9)}`
  }

  return (
    <footer className="footer mt-auto">
      <div className="container">
        <div className="row mx-auto">
          <div className="col-md-5 col-xs-12">
            <div className="first">
              <h3>{t('moduleFooter:S1.T')}</h3>
              <a
                href={t('moduleFooter:S1.Facebook.Link')}
                target="_blank"
                rel="noreferrer"
                title={t('moduleFooter:S1.Facebook.Title')}
              >
                <i className="fab fa-facebook-f font-size-icon" alt={t('moduleFooter:S1.Facebook.Alt')}></i>
              </a>
              <a
                href={t('moduleFooter:S1.Instagram.Link')}
                target="_blank"
                rel="noreferrer"
                title={t('moduleFooter:S1.Instagram.Title')}
              >
                <i className="fab fa-instagram font-size-icon" alt={t('moduleFooter:S1.Instagram.Alt')}></i>
              </a>
              <a
                href={t('moduleFooter:S1.Twitter.Link')}
                target="_blank"
                rel="noreferrer"
                title={t('moduleFooter:S1.Twitter.Title')}
              >
                <i className="fab fa-twitter font-size-icon" alt={t('moduleFooter:S1.Twitter.Alt')}></i>
              </a>
              <a
                href={t('moduleFooter:S1.Linkedin.Link')}
                target="_blank"
                rel="noreferrer"
                title={t('moduleFooter:S1.Linkedin.Title')}
              >
                <i className="fab fa-linkedin-in font-size-icon" alt={t('moduleFooter:S1.Linkedin.Alt')}></i>
              </a>
              <a
                href={t('moduleFooter:S1.Youtube.Link')}
                target="_blank"
                rel="noreferrer"
                title={t('moduleFooter:S1.Youtube.Title')}
              >
                <i className="fab fa-youtube font-size-icon" alt={t('moduleFooter:S1.Youtube.Alt')}></i>
              </a>
            </div>
          </div>

          <div className="col-md-4 col-xs-12">
            <div className="second links">
              <h3>{t('moduleFooter:S2.T')}</h3>
              <ul className="p-0">
                <li>
                  <a
                    href={t('moduleFooter:S2.P1.Link')}
                    target="_blank"
                    rel="noreferrer"
                    className="link_footer"
                  >
                    {t('moduleFooter:S2.P1.P')}
                  </a>
                </li>
                <li>
                  <a
                    href={t('moduleFooter:S2.P2.Link')}
                    target="_blank"
                    rel="noreferrer"
                    className="link_footer"
                  >
                    {t('moduleFooter:S2.P2.P')}
                  </a>
                </li>
                <li>
                  <a
                    href={t('moduleFooter:S2.P3.Link')}
                    target="_blank"
                    rel="noreferrer"
                    className="link_footer"
                  >
                    {t('moduleFooter:S2.P3.P')}
                  </a>
                </li>
                <li>
                  <a
                    href={t('moduleFooter:S2.P4.Link')}
                    className="link_footer"
                  >
                    {t('moduleFooter:S2.P4.P')}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-3 col-xs-12">
            <div className="third">
              <h3>{t('moduleFooter:S3.T')}</h3>
              <ul className="p-0">
                <li>
                  {t('moduleFooter:S3.P1')}
                </li>
                <li>
                  <a
                    className="link_footer"
                    href={"tel:+351" +
                    t('moduleFooter:S3.P2')}>
                    {formatPhoneValues(t('moduleFooter:S3.P2'))}
                  </a>
                </li>
                <li>
                  <a
                    className="link_footer"
                    href={"mailto:" + t('moduleFooter:S3.P3')}>
                  {t('moduleFooter:S3.P3')}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="textalign_footer">
            <p className="p_text_white p_next_footer">
              {t('moduleFooter:S4.P1.P1')}
              <a
                className="link_footer"
                href={t('moduleFooter:S4.P1.Link')}
                target="_blank"
                rel="noreferrer"
                title={t('moduleFooter:S4.P1.Title')}
              >
                {t('moduleFooter:S4.P1.P2')}
              </a>
              {t('moduleFooter:S4.P1.P3')}
            </p>
            <p className="p_text_white p_next">
              {t('moduleFooter:S4.P2')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default withNamespaces()(Footer);